// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._102v5{height:16px;width:16px}._2NtC2{position:relative}.Y8OHx{background:#f5f9ff;border-radius:50%;display:-ms-flexbox;display:flex;height:40px;width:40px;-ms-flex-pack:center;cursor:pointer;fill:#6f7ea2;justify-content:center}html[dir=ltr] .Y8OHx{margin-right:24px}html[dir=rtl] .Y8OHx{margin-left:24px}._1YFUa{display:-ms-flexbox;display:flex;font-size:12px;font-size:1.2rem;text-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}._1YFUa svg{fill:transparent;height:24px;height:2.4rem;width:22px;width:2.2rem}._1YFUa span{color:#fff;font-size:12px;font-weight:700;line-height:16px;padding-bottom:2px;position:absolute}._23SoW>svg{fill:#30a8ff}", ""]);
// Exports
exports.locals = {
	"icon": "_102v5",
	"notifications": "_2NtC2",
	"notifications__content": "Y8OHx",
	"notificationsBell": "_1YFUa",
	"notificationsBell--active": "_23SoW"
};
module.exports = exports;
